export default __webpack_public_path__ + "static/media/recharge-logo.5e700a58.svg";